exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".upload-area[data-v-74fc8767]{border:2px dashed #dbdbdb;border-radius:6px;padding:2rem;text-align:center;transition:all .2s}.upload-area[data-v-74fc8767]:hover{border-color:#b5b5b5}.upload-area.is-dragging[data-v-74fc8767]{border-color:#00d1b2;background-color:rgba(0,209,178,.05)}.template-box[data-v-74fc8767]{background-color:hsla(0,0%,96%,.8);border-radius:6px;padding:1rem}.template-content[data-v-74fc8767]{display:flex;justify-content:space-between;align-items:center;gap:1rem}.instruction-list[data-v-74fc8767]{list-style:none;padding:0;margin:0}.instruction-list li[data-v-74fc8767]{font-size:.875rem;line-height:1.6}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-74fc8767","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/cultura/sections/configuration/UploadCollaborators.vue
// module id = 1531
// module chunks = 2